var chunkToChildrenMap = {
	"1067": [
		1898,
		6773,
		7488
	],
	"1911": [
		1898,
		6773,
		7488
	],
	"3839": [
		4225,
		5501,
		1180,
		608,
		8731,
		7227,
		5882,
		2595,
		8660,
		6772,
		8020,
		100,
		5927,
		6535,
		8247,
		8629,
		1620,
		7189,
		1313,
		4140
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, () => {

}));